import {
    ACCOUNT,
    CHECKOUT,
    DATA_ACCESS,
    DISCOVER,
    DOWNGRADE_FUNNEL,
    DOWNGRADE_FUNNEL_BLOCKED,
    NOTIFICATIONS,
    NO_ACTIVE_SOCIAL_PROFILE,
    PLATFORM_OPTIONS,
    SCHEDULER,
    SECURITY,
    SOCIAL_PROFILES,
    SUBSCRIPTION,
    SUBSCRIPTION_INVOICES,
    THEMES,
    USERS_ROLES,
    MEDIA_LIBRARY,
    SCHEDULER_COLLABORATION_SETTINGS,
    SCHEDULER_COLLABORATION_NOTIFICATIONS,
    CAPTIONS_LISTS,
    SIGN_UP_URL_PATHNAME
} from '@/lib/routes/privateRoutes';

const URL_TWITTER_AFTER_MIGRATION_ALLOWED = [
    ACCOUNT,
    DATA_ACCESS,
    PLATFORM_OPTIONS,
    THEMES,
    SECURITY,
    SUBSCRIPTION,
    SUBSCRIPTION_INVOICES,
    USERS_ROLES,
    SOCIAL_PROFILES,
    NO_ACTIVE_SOCIAL_PROFILE,
    NOTIFICATIONS,
    SCHEDULER,
    CHECKOUT,
    DOWNGRADE_FUNNEL,
    DOWNGRADE_FUNNEL_BLOCKED,
    DISCOVER,
    MEDIA_LIBRARY,
    SCHEDULER_COLLABORATION_SETTINGS,
    SCHEDULER_COLLABORATION_NOTIFICATIONS,
    CAPTIONS_LISTS,
    SIGN_UP_URL_PATHNAME.USER_CREATED,
    SIGN_UP_URL_PATHNAME.USER_SET_UP,
    SIGN_UP_URL_PATHNAME.SOCIAL_PROFILES_CONNECTED
];

export { URL_TWITTER_AFTER_MIGRATION_ALLOWED };
